import { render, staticRenderFns } from "./msgTabs.vue?vue&type=template&id=28ad9a64&"
import script from "./msgTabs.vue?vue&type=script&lang=js&"
export * from "./msgTabs.vue?vue&type=script&lang=js&"
import style0 from "./msgTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports